import React from 'react';

import { HSpacer } from '@e4/ui';

const ItemContent = ({
  text,
  Icon,
  iconSize = '1.2rem',
  HSpacerProps = { small: 0.5 },
}) => (
  <>
    {text}
    {HSpacerProps && Icon && <HSpacer {...HSpacerProps} />}
    {Icon && <Icon width={iconSize} height={iconSize} />}
  </>
);

export default ItemContent;
